export const SPEECHIFY_VOICE_STORE_NAME = 'speechifyVoice';
